import Image from "next/image";
import { CheckCheck } from "lucide-react";
import { useRef } from "react";
import { motion, useInView } from "framer-motion";

const AboutSection = () => {
  const imageRef = useRef(null);
  const textRef = useRef(null);

  const isImageInView = useInView(imageRef, { once: true });
  const isTextInView = useInView(textRef, { once: true });

  const serviceItems = [
    {
      icon: "CheckCheck",
      text: 'Recommended by the biggest Bali expatriates group on Facebook, "Bali BOGANS".',
    },
    {
      icon: "CheckCheck",
      text: "Provides complete support for travel insurance claims, including medical certificates, detailed invoices, and other required documentation.",
    },
    {
      icon: "CheckCheck",
      text: 'Since 2005, Dr. Ari has provided 24/7 medical service clinics in Denpasar, continuing to serve patients to this day.',
    },
    {
      icon: "CheckCheck",
      text: "Trusted by leading travel agencies from around the world—including Danish, German, and Dutch agencies.",
    },
  ];

  return (
    <section className='py-12  lg:py-32 px-4 sm:px-6 lg:px-[145px]'>
      <div className='container'>
        <div className=' flex flex-col-reverse lg:flex lg:flex-row lg:justify-between lg:items-center '>
          <motion.div ref={textRef} initial={{ opacity: 0, y: 100 }} animate={isTextInView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }} className='md:w-1/2 lg:w-full lg:h-full'>
            <div className='md:w-1/2 lg:w-[557px] lg:h-full '>
              <div className='text-sm text-teal-500 mb-2'>ABOUT US</div>
              <h1 className='text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-800 mb-4 leading-normal'>
                Welcome to Dr Ari & <br /> Associates Medical Care
              </h1>
              <p className='text-gray-600 mb-6'>Dr. Ari Sudhewa, also known as Dr. Ari, has been a trusted doctor for travelers, expatriates, and tourists on holiday in Bali since 1998.</p>

              <div className='flex flex-wrap gap-2 mb-6'>
                {serviceItems.map((item, idx) => (
                  <div key={idx} className='flex items-start space-x-2'>
                    <CheckCheck className='text-green-500 w-4 h-4 mt-1.5 flex-shrink-0' />
                    <p className='text-sm text-gray-700'>{item.text}</p>
                  </div>
                ))}
              </div>
            </div>
          </motion.div>
          <div className='lg:flex justify-between   lg:mb-0 mb-12'>
            <motion.div ref={imageRef} initial={{ opacity: 0, y: 100 }} animate={isImageInView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.8, ease: "easeOut" }} className='lg:flex justify-between lg:mb-0 mb-12'>
              <Image src='/images/logo_bogans.webp' alt='Medical Team' width={700} height={400} className='object-cover rounded-lg' />
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
